import * as React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import CustomerPolicyAnswersDetails from './CustomerPolicyAnswersDetails';
import PolicyAnswerModal from '../common/PolicyAnswerModal';
import * as toastr from 'toastr';

import policyActions from '../../policy/policyActions';
import userActions from '../../user/userActions';

import Utils from '../../common/utils';

interface Props {
	actions: any;
	history?: any;
	match: any;
	answers: PolicyAnswerWithDeclineInfoDto;
	notes: CustomerNote[];
	note: CustomerNote;
	questions: { [name: string]: string; }[];
	allowFormat: boolean;
}
interface State {
	isLoading: boolean;
	isAnswerModalOpen: boolean;
	questionAnswerPair: ApplicationAnswerDto;
}

class CustomerPolicyAnswersPage extends React.Component<Props, State> {
	constructor(props: Props) {
		super(props);
		this.state = {
			isLoading: false,
			isAnswerModalOpen: false,
			questionAnswerPair: {},
		};
	}

	componentDidMount() {
		this.loadData();
	}

	componentWillUnmount() {
		this.props.actions.resetCustomerPolicyAnswer();
	}

	loadData = () => {
		this.props.actions.fetchCustomerNotes(this.props.match.params.customerId);
	}

	onRequestClose = () => {
		this.setState({isAnswerModalOpen: false});
	}

	onRowClick = (e: any, answerId?: string) => {
		e.stopPropagation();
		const clickedItem = this.props.answers.answerList!.find(a => a.id === answerId);
		const note = this.props.notes.find(n => n.answerId === answerId);
		if (note) {
			this.props.actions.setCustomerNote(note);
		} else {
			this.props.actions.resetCustomerAnswerNote(this.props.match.params.customerId, answerId);
		}
		this.setState({questionAnswerPair: clickedItem!});
		this.setState({isAnswerModalOpen: true});
	}

	onNoteChange = (e: any) => {
		const note = {
			...this.props.note,
			[e.target.name]: e.target.value,
			customerId: this.props.match.params.customerId
		};

		this.props.actions.setCustomerNote(note);
	}

	onNoteSave = () => {
		let note = {...this.props.note};
		if (note.notes === '') {
			toastr.error('There\'s no content to save');
			return;
		}
		if (this.props.match.params.customerId) {
			note.customerId = this.props.match.params.customerId;
		}
		this.setState({isLoading: true});
		note.answerInfo = Utils.getCategoryInfoByNoteAnswerId(note.answerId);
		this.props.actions.saveCustomerNote(note)
		.then(() => {
			this.loadData();
			this.setState({isAnswerModalOpen: false, isLoading: false});
		});
	}

	render() {
		return(
			<div>
				<CustomerPolicyAnswersDetails 
					history={this.props.history}
					answers={this.props.answers}
					isLoading={this.state.isLoading}
					onRowClick={this.onRowClick}
					questions={this.props.questions}
					allowFormat={this.props.allowFormat}
				/>
				<PolicyAnswerModal
					isOpen={this.state.isAnswerModalOpen}
					onRequestClose={this.onRequestClose}
					declinedQuestionNames={this.props.answers.declinedQuesitonNames!}
					questionAnswerPair={this.state.questionAnswerPair}
					questionAnswerPairNote={this.props.note}
					questions={this.props.questions}
					onNoteChange={this.onNoteChange}
					onNoteSave={this.onNoteSave}
					allowFormat={this.props.allowFormat}
				/>
			</div>
		);
	}
}

function mapStateToProps(state: any) {
	return {
		notes: state.user.notes,
		note: state.user.note,
		questions: state.question.questions
	};
}

function mapDispatchToProps(dispatch: any) {
	const actions = { ...policyActions, ...userActions };
	return {
		actions: bindActionCreators(actions, dispatch)
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(CustomerPolicyAnswersPage);


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/admin/customers/CustomerPolicyAnswersPage.tsx